import * as angular from 'angular';
import { HttpService } from '../../../../app.common/modules/api/http.service';
import { RetailerService } from '../../api/retailer.service';
import { IPrinter, ITestPrintResult, IUpdatePrinter } from '../models/models';

export class PrintersService {
    public static $inject = [
        'http',
        'retailerService'
    ];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
    ) {
    }

    public getPrinterList(): Promise<IPrinter[]> {
        return this.http.get<IPrinter[]>(this.retailerService.printerSettings());
    }

    public getPrinter(printerID: number, placeID: number): Promise<IPrinter> {
        const params = {
            PrinterID: printerID,
            PlaceID: placeID
        };
        return this.http.get<IPrinter>(this.retailerService.printerSettingsByPrinter(), {params});
    }

    public createPrinter(printer: IUpdatePrinter): angular.IPromise<void> {
        return this.http.post(this.retailerService.printerSettings(), printer);
    }

    public updatePrinter(printer: IUpdatePrinter): angular.IPromise<void> {
        return this.http.put(this.retailerService.printerSettings(), printer);
    }

    public deletePrinter(printerID: number, placeID: number): Promise<void> {
        const data = {
            PrinterID: printerID,
            PlaceID: placeID
        };
        return this.http.delete(this.retailerService.printerSettings(), {
            data,
            headers: {'Content-Type': 'application/json'}
        });
    }

    public testPrint(printerID: number, placeID: number): Promise<ITestPrintResult> {
        const data = {
            PrinterID: printerID,
            PlaceID: placeID
        };
        return this.http.post<ITestPrintResult>(this.retailerService.testPrinting(), data);
    }
}

angular
    .module('naut')
    .service('printersService', PrintersService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/printers/services/printers.service.ts